export default "__VITE_ASSET__CJoVpOSh__"